export enum EditGoalModalProps {
  ALLPRODUCTSHEADING = 'Set Total kgCO\u2082e Goal For All Products',
  COMPANYHEADING = 'Set total kgCO\u2082e goal for the company',
  LOADING_INDICATOR = 'Loading...',
  MODAL_WIDTH = 375,
  EMISSION_VALUE = '',
}

export enum FieldLabels {
  EMISSION_GOAL = 'goal',
  EMISSION_PLACEHOLDER = 'Enter kgCO\u2082e value',
  EMISSON_LABEL = 'Total kgCO\u2082e goal for the product annually',
}

export enum ButtonLabels {
  CONFIRM = 'Update',
  CANCEL = 'Cancel',
  SET = 'Set',
}
